/** Node box metrics shared by the canvas and browser-independent graph auto-layout. */
export const NODE = {
  width: 148,
  headerHeight: 26,
  bodyHeight: 148,
  radius: 8,
  portRadius: 5,
  portHitRadius: 11,
  /** Horizontal gap between node columns used by auto-layout. */
  columnGap: 96,
  rowGap: 32,
} as const;

export function nodeHeight(collapsed: boolean | undefined): number {
  return collapsed ? NODE.headerHeight : NODE.headerHeight + NODE.bodyHeight;
}
